{
    "api": {
        "insightsTrackerURL": "https://tracker.akixi.com/Webhook/InsightsTracker",
        "maxCommStatusChecks": 1000,
        "commsInactiveGraceChecks": 70,
        "heartbeatPeriodMillisecs": 1000,
        "maxSyncedDevicesChecks": 20,
        "timestampLocale": "en-GB"
    },
    "telServerDefaults": {
        "commsEnabled": true,
        "billingTag": "InsightsFOC",
        "telSysType": "BroadSoft BroadWorks",
        "ipAddrHost1": "127.0.0.1",
        "xsiEvents": "/xsi-events",
        "xsiActions": "/xsi-actions"
    },
    "partitionDefaults": {
        "commsEnabled": true,
        "telSysComponentType": "BroadWorks Enterprise",
        "licenceLevel": "Enterprise",
        "syncNow": true,
        "syncType": 2,
        "syncOptions": "Extensions (Endpoint)",
        "billedMonthly": true
    },
    "userDefaults": {
        "REPORTING_SUPERVISOR": {
            "licenceLevel": "Enterprise",
            "mobileAppEnabled": true,
            "defaultReportsCollection": "Standard_Reports",
            "isSelfScoped": false,
            "requiresEndpoint": true,
            "allowEmailAsUsername": true
        },
        "ONE_USER": {
            "licenceLevel": "Akixi ONE",
            "mobileAppEnabled": true,
            "defaultReportsCollection": "Standard_Reports",
            "isSelfScoped": false,
            "requiresEndpoint": true,
            "allowEmailAsUsername": true
        }
    },
    "industries": [
        "Construction_Manufacturing",
        "Education",
        "Financial_Services",
        "IT",
        "Healthcare",
        "Hospitality",
        "Legal_Professional_Services",
        "Non_Profit",
        "Retail",
        "Transport_Logistics",
        "Other"
    ]
}